import styled from '@emotion/styled'

export const Right = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    display: 'block',
    transition: 'transform 1s ease',
  },
}))

export const Body = styled('div')(({ theme }) => ({
  background: theme.colors.N0,
  overflow: 'hidden',
  '& a': {
    color: theme.colors.B300
  },
  '& ul': {
    marginBottom: 0,
    '& li': {
      lineHeight: '22px',
      '&:not(:last-child)': {
        marginBottom: 10,
      },
    },
  },
}))
export const Item = styled('div', {
  shouldForwardProp: prop => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  padding: 12,
  borderBottom: `1px solid ${theme.colors.N40}`,
  '&:last-child': {
    borderBottom: 0,
  },
  [`${Right}`]: {
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  },
  [`${Header}`]: {
    marginBottom: open ? 10 : 0,
  },
}))
export const Header = styled('div')(({ theme }) => ({
  background: theme.colors.N0,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '& p': {
    fontWeight: theme.fontWeights.medium,
  },
  '&:hover': {
    cursor: 'pointer',
  },
  [theme.breakpoint.down('md')]: {
    '& p': {
      maxWidth: '90%',
    },
  },
}))
export const AccordionWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'rendered',
})<{ rendered?: boolean }>(({ theme, rendered }) => ({
  overflow: 'hidden',
  borderRadius: 8,
  width: 'auto',
  border: `1px solid ${theme.colors.N40}`,
  [`${Body}`]: {
    transition: rendered ? 'height 0.3s ease' : '',
  },
}))
